import React, { useState, useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label, Input, Col, Row, Table } from 'reactstrap';
import axios from 'axios'


const Attendees = (props) => {

    return (
        <Modal isOpen={props.modal} size='lg' toggle={() => props.toggle(false)}>
            <ModalHeader toggle={() => props.toggle(false)}>Attendees</ModalHeader>
            <ModalBody>
                <Table>
                    {props.guests?.length > 0 && <Table style={{ width: '100%' }} >
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>D.O.B</th>
                                <th>ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.guests.map((guest, i) => <tr>
                                <td style={{ width: "33.33%" }}>{guest.name}</td>
                                <td style={{ width: "33.33%" }}>{new Date(guest.dob).toLocaleDateString()}</td>
                                <td style={{ width: "33.33%" }}>{guest.validId}</td>
                            </tr>)}
                        </tbody>
                    </Table>}
                </Table>
            </ModalBody>
        </Modal>
    );
}

export default Attendees;